import { PrivacyLayout } from "@features/layout/privacy";

export const PrivacyPage = () => {
  return <PrivacyLayout />;
};
